import { Collection } from 'modules/core/lib/mobx-rest'

import MaterializedApprovalFlow from 'modules/approvals/store/models/MaterializedApprovalFlow'

export class MaterializedApprovalFlows extends Collection<MaterializedApprovalFlow> {
  get cacheKey(): string {
    return 'materializedApprovalFlows'
  }

  model() {
    return MaterializedApprovalFlow
  }
}
